import axios from "axios"

export const downloadFile = async (
  url: string,
  filename: string = "downloaded-file"
) => {
  try {
    // Fetch the file as a blob
    const response = await axios.get(url, { responseType: "blob" })

    // Create an object URL from the blob
    const blobUrl = URL.createObjectURL(response.data)

    // Create a temporary anchor element and trigger download
    const a = document.createElement("a")
    a.href = blobUrl
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()

    // Clean up the object URL after a short delay
    setTimeout(() => {
      URL.revokeObjectURL(blobUrl)
    }, 100)
  } catch (error) {
    console.error("Error downloading file:", error)
    throw error
  }
}
